const SignatureIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Document outline */}
    <rect x="4" y="3" width="16" height="18" rx="2" fill="currentColor" fillOpacity="0.08" />
    <rect x="4" y="3" width="16" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
    {/* Folded corner */}
    <path d="M16 3v4a1 1 0 0 0 1 1h4" stroke="currentColor" strokeWidth="1.5" fill="none" />
    {/* Signature line */}
    <path
      d="M8 17c.5 1 2 1 2.5 0 .5-1 1.5-1 2 0 .5 1 2 1 2.5 0"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* Pen tip */}
    <path d="M15.5 17.5l1.2 1.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default SignatureIcon;
